import axios from 'axios';
import Cookies from 'js-cookie';

const axiosClient = axios.create({
    baseURL: process.env.REACT_APP_END_POINT,
});

let isRedirecting = false;

const isTokenExpiredResponse = (data, httpStatus) => {
    if (httpStatus === 401) {
        return true;
    }
    if (data && typeof data === 'object') {
        const msg = (data.message || data.msg || '').toString().toLowerCase();
        if (
            msg.includes('jwt expired') ||
            msg.includes('token expired') ||
            msg.includes('jwt malformed') ||
            msg.includes('invalid token') ||
            msg.includes('please authenticate') ||
            msg.includes('jwt signature is required') ||
            msg.includes('jwt must be provided')
        ) {
            return true;
        }
        if (data.statusCode === 401) {
            return true;
        }
    }
    return false;
};

const handleTokenExpired = () => {
    if (isRedirecting) return;
    isRedirecting = true;

    // Clear all auth cookies and stored user session data
    Cookies.remove('token', { path: '/' });
    Cookies.remove('agentDetails', { path: '/' });
    Cookies.remove('userDetails', { path: '/' });
    Cookies.remove('agentData', { path: '/' });
    Cookies.remove('userdata', { path: '/' });
    localStorage.removeItem('agentData');
    localStorage.removeItem('userdata');

    // Auto-redirect to login page
    if (window.location.pathname !== '/') {
        window.location.replace('/');
    } else {
        window.location.reload();
    }
};

const isResetPasswordFlow = (config) => {
    const url = (config?.url || '').toString();
    const pathname = (typeof window !== 'undefined' && window.location?.pathname) || '';
    return (
        url.includes('resetPassword') ||
        pathname.includes('/app-reset-password') ||
        pathname.includes('/reset-password')
    );
};

axiosClient.interceptors.response.use(
    function (response) {
        if (!isResetPasswordFlow(response?.config) && isTokenExpiredResponse(response?.data, response?.status)) {
            handleTokenExpired();
            return Promise.reject(new Error(response?.data?.message || 'Token Expired'));
        }
        return response;
    },
    function (error) {
        const res = error?.response;
        if (!isResetPasswordFlow(error?.config) && isTokenExpiredResponse(res?.data, res?.status)) {
            handleTokenExpired();
        }
        if (res?.status) {
            console.error('Looks like there was a problem. Status Code:' + res.status);
        }
        return Promise.reject(error);
    }
);

axiosClient.interceptors.request.use(function (config) {
    const token = Cookies.get('token');
    config.headers['Authorization'] = token || '';
    return config;
});

export default axiosClient;